import { Outlet } from "react-router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchChecklistID } from "../features/userReducer.js"
import { Menu } from "../components/menu/menu.jsx";
import { MenuItem } from "../components/menu/menuItem.jsx";
import { IncomeIcon, KnowledgeBaseIcon, MainPageIcon, ProfileIcon, TasksIcon } from "../assets/icons.jsx";
import { useAnimatedNavigate } from "../hooks/useAnimatedNavigate.js";
import { PageLoader } from "../components/loader/pageLoader.jsx";
import UserAPI from "../api/UserAPI.js";
import { BackButton } from "../components/backButton/backButton.jsx";

export const UserTemplate = () => {
    const navigate = useAnimatedNavigate();
    const dispatch = useDispatch();

    const loaded = useSelector(state => state.user.loaded);
    const cafeId = useSelector(state => state.user?.userData?.cafeId);
    const isAdmin = useSelector(state => state.status.isAdmin);
    const isSuperAdmin = useSelector(state => state.status.isSuperAdmin);

    const [isAgreed, setIsAgreed] = useState(false);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        UserAPI.fetchDocsAgreement()
            .then(isAgreed => {
                if (!isAgreed) {
                    setIsAgreed(false);
                    navigate("/user_policy");
                } else {
                    setIsAgreed(true);
                }
            })
            .finally(() => setLoading(false));
    }, [navigate]);

    useEffect(() => {
        dispatch(fetchChecklistID());
    }, [dispatch]);

    useEffect(() => {
        if (!loaded || !isAgreed) return;

        if (!cafeId && isAdmin) {
            navigate("/admin");
        } else if (!cafeId && isSuperAdmin) {
            navigate("/superadmin");
        }
    }, [isAgreed, loaded, cafeId, isAdmin, isSuperAdmin, navigate]);

    let menuItems = [
        <MenuItem key="main" path="/" icon={<MainPageIcon />} text="Задачи" />,
    ];

    if (cafeId) {
        menuItems = menuItems.concat(
            [
                <MenuItem key="tasks" path="/tasks" icon={<TasksIcon />} text="Продажи" />,
                <MenuItem key="income" path="/income" icon={<IncomeIcon />} text="Доход" />,
            ]
        );
    }

    menuItems = menuItems.concat(
        [
            <MenuItem key="knowledge" path="/knowledge" icon={<KnowledgeBaseIcon />} text="База знаний" />,
            <MenuItem key="profile" path="/profile" icon={<ProfileIcon />} text="Профиль" />,
        ]
    );

    if (loading || !loaded) {
        return <PageLoader />;
    }

    return (
        <div className="page_container">
            <div className="page_content">
                <BackButton stopRoutes={["materials", "tests"]}/>
                <Outlet />
            </div>
            <Menu>
                {menuItems}
            </Menu>
        </div>
    )
}